import React from "react";
import {
  Form,
  Input,
  Select,
  Radio,
  Button,
  Row,
  Col,
  Typography,
  Space,
  DatePicker,
} from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

type PortalRegistrationProps = {
  form: any;
  handleSubmit: any;
  isSubmitting: boolean;
};

const PortalRegistration: React.FC<PortalRegistrationProps> = ({
  form,
  handleSubmit,
  isSubmitting,
}) => {
  const onFinish = async (values: any) => {
    try {
      await form.validateFields();
      handleSubmit();
    } catch (err) {}
  };

  return (
    <div
      style={{
        maxWidth: 420,
        margin: "auto",
        background: "#f5f7fb",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          padding: "8px 16px",
          background: "white",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
        }}
        className="patient-registration"
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#004C8F",
                }}
              >
                Patient Registration
              </span>

              <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#2ecc71",
                  borderRadius: "50%",
                }}
              />
            </div>

            <div
              style={{
                border: "1px solid #AADFFF",
                padding: "8px 16px",
                borderRadius: "10px",
              }}
            >
              <Row gutter={[2, 2]} style={{ marginTop: "10px" }}>
                <Col span={24}>
                  <div className="floating-wrapper">
                    <label className="floating-static-label">
                      Beneficiary Id <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      // label="Beneficiary ID"
                      name="beneficiaryId"
                      rules={[
                        {
                          required: true,
                          message: "Beneficiary ID is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder=" "
                        //   disabled={portalData?.schemeRegistrationId}
                        style={{ fontSize: "10px" }}
                        className="input-field"
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={24}>
                  <div className="floating-wrapper">
                    <label className="floating-static-label">
                      REGISTRATION DATE <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      // label="REGISTRATION DATE"
                      name="registrationDate"
                      rules={[
                        {
                          required: true,
                          message: "Registration Date is Required",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", fontSize: "10px" }}
                        format={"DD-MM-YYYY HH:mm:ss"}
                        className="input-field"
                        disabledDate={(current) => {
                          const now = dayjs().endOf("day");
                          const firstAllowedDate = dayjs().startOf("year");

                          return (
                            current.isBefore(firstAllowedDate, "day") ||
                            current.isAfter(now, "day")
                          );
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={24}>
                  <div className="floating-wrapper">
                    <label className="floating-static-label">
                      REGISTRATION ID <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      // label="REGISTRATION ID"
                      name="registrationId"
                      rules={[
                        {
                          required: true,
                          message: "REGISTRATION ID is required",
                        },
                        {
                          pattern: /^\S+$/,
                          message: "REGISTRATION ID must not contain spaces",
                        },
                      ]}
                    >
                      <Input
                        placeholder=" "
                        //   disabled={portalData?.schemeRegistrationId}
                        style={{ fontSize: "10px" }}
                        className="input-field"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="small"
            loading={isSubmitting}
            style={{
              borderRadius: 6,
              background: "#004C8F",
              marginTop: "10px",
            }}
            // disabled={!(isMobileVerified && isOtpVerified)}
          >
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default PortalRegistration;
